"use client";
import { useState } from "react";
import type { ApiErrorBody } from "./types";

/** フォームの送信中・エラーの状態 */
export function useSubmit() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async (fn: () => Promise<void>) => {
    setBusy(true);
    setError(null);
    try { await fn(); } finally { setBusy(false); }
  };
  return { busy, error, setError, run };
}

/** 登録・ロックの失敗を、次に何をすればよいかが分かる文言に（S-01b, H-8） */
export function lockText(e: ApiErrorBody): string {
  if (e.error === "mismatch" && e.remaining !== undefined) return `利用者コードまたは生年月日が違います。あと${e.remaining}回間違えると、しばらく手続きできなくなります。`;
  if (e.error === "locked" && e.until) {
    const min = Math.max(1, Math.round((new Date(e.until).getTime() - Date.now()) / 60_000));
    const wait = min < 60 ? `${min}分ほど` : min < 24 * 60 ? `${Math.round(min / 60)}時間ほど` : "1日ほど";
    return `間違いが続いたため、手続きを止めています。${wait}経ってからもう一度お試しください。`;
  }
  return e.message ?? "うまくいきませんでした。もう一度お試しください。";
}
